import "matchmedia-polyfill";
import "matchmedia-polyfill/matchMedia.addListener";

export { wrapRootElement } from "./src/components/wrapRootElement";
export { wrapPageElement } from "./src/components/wrapPageElement";
